(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["agbb-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initTabCollections(container) {
      const sections = container.querySelectorAll('.agbb-tab-collections');

      sections.forEach((section) => {
        if (section.dataset.tabsInitialized) return;
        section.dataset.tabsInitialized = 'true';

        const tabs = Array.from(section.querySelectorAll('.agbb-tab-collections__tab'));
        const panels = Array.from(section.querySelectorAll('[role="tabpanel"]'));

        if (tabs.length <= 1) return;

        function activateTab(tab, moveFocus = false) {
          tabs.forEach((t) => {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
            t.setAttribute('tabindex', '-1');
          });

          panels.forEach((p) => {
            p.hidden = true;
            p.classList.remove('is-active');
          });

          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          tab.setAttribute('tabindex', '0');

          if (moveFocus) tab.focus();

          const panelId = tab.getAttribute('aria-controls');
          const panel = section.querySelector(`#${panelId}`);

          if (panel) {
            panel.hidden = false;
            panel.classList.add('is-active');
          }
        }

        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => activateTab(tab, false));

          tab.addEventListener('keydown', (e) => {
            let targetIndex = null;

            if (e.key === 'ArrowRight') {
              targetIndex = (index + 1) % tabs.length;
            }

            if (e.key === 'ArrowLeft') {
              targetIndex = (index - 1 + tabs.length) % tabs.length;
            }

            if (targetIndex !== null) {
              e.preventDefault();
              activateTab(tabs[targetIndex], true);
            }
          });
        });
      });
    }

    /* ---------- Initial Page Load ---------- */
    document.addEventListener('DOMContentLoaded', () => {
      initTabCollections(document);
    });

    /* ---------- Shopify Theme Editor Support ---------- */
    document.addEventListener('shopify:section:load', (e) => {
      initTabCollections(e.target);
    });

    document.addEventListener('shopify:section:reorder', (e) => {
      initTabCollections(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
